module.exports = "/assets/data/e06aa0a276ce8b4bfb74bf84dcda4d36-WR15.data.json";